import React from 'react'

import { Link, useHistory } from 'react-router-dom'
import { RHFInput } from 'react-hook-form-input'
import useForm from 'react-hook-form'

import { Box, Typography } from '@material-ui/core'

import { routes } from 'routes'
import { Footer, PaymentMethodCheckbox } from './components'
import PaymentMethodsContext from 'contexts/PaymentMethodsContext'
import billet from 'images/paymentMethodsConfiguration/billet.png'
import transfer from 'images/paymentMethodsConfiguration/transfer.png'
import creditCard from 'images/paymentMethodsConfiguration/creditCard.png'
import balance from 'images/paymentMethodsConfiguration/balance.png'

const PaymentMethodsSelectMethods = () => {
  const history = useHistory()
  const context = React.useContext(PaymentMethodsContext)
  const { register, setValue, handleSubmit } = useForm({
    defaultValues: {
      ...context.data.selectMethods,
    },
  })

  const onSubmit = dataForm => {
    context.setData(data => ({
      ...data,
      selectMethods: { ...data.selectMethods, ...dataForm },
    }))

    history.push(routes.settings.paymentMethods.steps.configuration)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box mb={2}>
        <Typography color="textSecondary">
          Agora, selecione as formas de pagamento que irá aceitar.
        </Typography>
      </Box>

      <Box
        display="grid"
        gridTemplateColumns={{
          xs: '1fr 1fr',
          sm: 'repeat(auto-fill, 130px)',
        }}
        gridGap={4}
        mb={4}
      >
        <RHFInput
          as={
            <PaymentMethodCheckbox
              id="billet"
              image={billet}
              imageAlt="Boleto"
              description="Boleto"
            />
          }
          name="billet"
          type="checkbox"
          register={register}
          setValue={setValue}
        />

        <RHFInput
          as={
            <PaymentMethodCheckbox
              id="transfer"
              image={transfer}
              imageAlt="Transferência bancária"
              description="Transferência bancária"
            />
          }
          name="transfer"
          type="checkbox"
          register={register}
          setValue={setValue}
        />

        <RHFInput
          as={
            <PaymentMethodCheckbox
              id="creditCard"
              image={creditCard}
              imageAlt="Cartão de crédito"
              description="Cartão de crédito"
            />
          }
          name="creditCard"
          type="checkbox"
          register={register}
          setValue={setValue}
        />

        <RHFInput
          as={
            <PaymentMethodCheckbox
              id="balance"
              image={balance}
              imageAlt="Saldo Yapay"
              description="Saldo Yapay"
            />
          }
          name="balance"
          type="checkbox"
          register={register}
          setValue={setValue}
        />
      </Box>

      <Footer
        prevButtonProps={{
          component: Link,
          to: routes.settings.paymentMethods.steps.integrationToken,
        }}
        nextButtonProps={{ type: 'submit' }}
      />
    </form>
  )
}

export default PaymentMethodsSelectMethods
